import * as React from 'react';

import { observer } from 'mobx-react';

import { Field, FormInput } from '@estee/elc-form';

import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/RampService';
import { textInputFieldClasses } from '~utils/Classes';
import { FieldValidations } from '~utils/FieldValidations';
import { PasswordViewController } from '~views/components/PasswordViewController';

export interface IPasswordProps {
    name: string;
    maxLength: number;
    disabled: boolean;
    inputType: string;
    inputLabel: string;
    fieldValidations: FieldValidations;
    enableChecker?: boolean;
}

@observer
export class Password extends React.Component<IPasswordProps> {
    private passwordViewController: PasswordViewController;

    constructor(props: IPasswordProps) {
        super(props);
        this.passwordViewController = diContainer.get(serviceNames.passwordViewController);
    }

    public componentDidMount() {
        this.passwordViewController.loaded(this.props);
    }

    public render() {
        const {
            name,
            inputType,
            inputLabel,
            disabled,
            fieldValidations,
            ...restProps
        } = this.props;
        const { isRequired, maxLength, validations } = fieldValidations || {};
        const { onPress } = this.passwordViewController;

        return (
            <Field
                {...restProps}
                name={name}
                inputType={inputType}
                inputLabel={inputLabel}
                customClassName={textInputFieldClasses(name)}
                isRequired={isRequired}
                disabled={disabled}
                maxLength={maxLength}
                dataTestId={`form_${name}`}
                component={FormInput}
                afterChange={onPress}
                showPasswordLabel={`form_${name}`}
                showPasswordDataTestId={`form_reveal_${name}`}
                validations={validations}
            />
        );
    }
}
